module.exports = __webpack_public_path__ + "img/equipmentpoint.6ae3c669.svg";